import { send } from '../../../../../../src/network';
import { type CustomerFavorites } from '../../../../../../src/types/CustomerFavorites';

interface PostFavoritePairingPostBody {
  pairing_id: number;
}

export interface PostFavoritePairingParams {
  body: PostFavoritePairingPostBody;
}

export function postFavoritePairingPath() {
  return `/api/v2/customers/self/favorite_pairings/`;
}

export async function postFavoritePairing({ body }: PostFavoritePairingParams) {
  return await send<CustomerFavorites>({
    path: postFavoritePairingPath(),
    method: 'POST',
    body,
  });
}
